<template>
<el-config-provider :locale="locale">
  <div>
    <h3>Información General</h3>
    <div
      class="card"
      v-if="form"
      v-loading="loading"
      element-loading-text="Cargando..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
    >
      <div class="card-body">
        <form @submit.prevent="submit" id="upload" enctype="multipart/form-data" method="post">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Nombre del Profesor</label>
                    <input
                      type="text"
                      v-model="form.name"
                      class="form-control"
                      placeholder="Jose Morales"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>email</label>
                    <input
                      type="email"
                      v-model="form.email"
                      class="form-control"
                      placeholder="ejemplo@gmail.com"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Número de teléfono</label>
                    <input
                      type="text"
                      v-model="form.phone"
                      class="form-control"
                      placeholder=" ejemplo 965435654"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Tipo de Documento</label>
                      <select v-model="form.doc_type_id" id="item">
                          <option value="0" disabled selected>Seleccione Documento</option>
                          <option v-for="item in this.courseCategory" :value="item.id">{{item.name}}</option>
                      </select>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Número de Documento</label>
                    <input
                      type="text"
                      v-model="form.number_doc"
                      class="form-control"
                      placeholder="Inserte documento"
                    />
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Cumpleaños</label>
                    
                    <el-date-picker
                      v-model="form.birthday"
                      type="date"
                      placeholder="Seleccione una fecha"
                      format="YYYY/MM/DD"
                    />
                   
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group">
                    <label>Prefijo</label>
                    <input
                      type="text"
                      v-model="form.prefix"
                      class="form-control"
                      placeholder="Ejemplo: Ing. / Dr. / Arq."
                    />
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Descripción</label>
                    <textarea
                      class="form-control"
                      v-model="form.description"
                      rows="5"
                      style="resize: none"
                      placeholder="Descripción del curso"
                    ></textarea>
                  </div>
                </div>

                

              </div>
            </div>
            <div class="col-lg-6">
              <label>Subir Portada</label>
              <el-upload
                class="picture-card"
                ref="courseUpload"
                action=""
                drag
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                :on-change="onUploadChange"
                :http-request="submit"
                :multiple="false"
                :limit="1"
                :auto-upload="false"
                :file-list="fileList"
                :on-exceed="handleExceed"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Suelta tu archivo aquí o <em>haz clic para cargar</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  Solo archivos jpg/png con un tamaño menor de 100kb
                </div>
              </el-upload>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-success" :disabled="isSubmitting">Guardar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</el-config-provider>
</template>
<script>

import es from 'element-plus/dist/locale/es.mjs'

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },

  setup() {
      return {
        locale: es,
      }
  },

  data() {
    return {
      loading: false,
      extensions: '.jpeg, .jpg, .png',
      categories: [],
      form: null,
      fileList: [],
      courseCategory: [],
      isSubmitting: false,
      url: 'https://ipssoma-storage.s3.eu-west-1.amazonaws.com/',
    };
  },

  watch: {
    course: function (value) {
      this.form = value;
      this.fillFiles();
      this.listCourseCategory();
    },
  },
    methods: {
    fillFiles() {
      this.fileList = [
        {
          name: 'imagen',
          url:`${this.url}${this.form.img}`,
        },
      ];
    },

    listCourseCategory() {
      axios
        .get(`/document-types`)
        .then((response) => {
          if (response.data.error) {
            //
          } else {
            Object.keys(response.data).map((key) => {
              this.courseCategory.push(response.data[key]);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleExceed(file) {
      const isLt1M = file.size > 100000;

      if (!isLt1M) {
        this.$message.error('El archivo no debe pesar más de 100kb!');
        this.$refs.courseUpload.clearFiles();
        return false;
      }
    },
    onUploadChange(file) {
      this.fileList = [];

      const isImage =
        file.raw.type === 'image/jpeg' ||
        file.raw.type === 'image/png' ||
        file.raw.type === 'image/webp' ||
        file.raw.type === 'image/jpg';

      // 100kb
      const isLt1M = file.size < 100000;

      if (!isImage) {
        this.$message.error('Solo puede cargar archivos en formato jpg|jpeg|png y webp.');
        this.$refs.courseUpload.clearFiles();
        return false;
      }
      if (!isLt1M) {
        this.$message.error('El archivo no debe pesar más de 100kb!');
        this.$refs.courseUpload.clearFiles();
        return false;
      }
      this.fileList.push(file);
    },

    handleLevelChange(value) {
      if (value == 1) {
        this.form.price = '0';
      }
    },
    
    hasEspecialCharacters(text) {
      // Solo puede contener vocales con tilde A-Z  y 0-9
      const regex = new RegExp(/^[A-Za-z0-9\s\u00f1\u00d1-áéíóúÁÉÍÓÚ]+$/g);
      return regex.test(text);
    },
    validateFields() {
      if (!this.form.name || this.form.name.trim() === '' || this.form.name.length === 0) {
        this.$message.warning('Nombre esta vacio!');
        return false;
      }

      if (this.form.name.length > 50) {
        this.$message.warning('Nombre demasiado largo!');
        return false;
      }

      if (!this.form.email || this.form.email.trim() === '' || this.form.email.length === 0) {
        this.$message.warning('Email esta vacio!');
        return false;
      }

      if (this.form.email.length > 50) {
        this.$message.warning('Email demasiado largo!');
        return false;
      }

      if (!this.form.phone || this.form.phone.trim() === '' || this.form.phone.length === 0) {
        this.$message.warning('Numero esta vacio!');
        return false;
      }

      if (this.form.phone.length > 12) {
        this.$message.warning('Numero demasiado largo!');
        return false;
      }

      if (this.form.doc_type_id == 0) {
        this.$message.warning('No ha seleccionado tipo de documento!');
        return false;
      }

      if (!this.form.number_doc || this.form.number_doc.trim() === '' || this.form.number_doc.length === 0) {
        this.$message.warning('Numero de documento esta vacio!');
        return false;
      }

      if (this.form.number_doc.length > 12) {
        this.$message.warning('Numero de documento es demasiado largo!');
        return false;
      }

      if (!this.form.birthday) {
        this.$message.warning('Fecha de nacimiento esta vacio!');
        return false;
      }

      if (!this.form.prefix || this.form.prefix.trim() === '' || this.form.prefix.length === 0) {
        this.$message.warning('Numero de documento esta vacio!');
        return false;
      }

      if (this.form.prefix.length > 12) {
        this.$message.warning('Prefijo es demasiado largo!');
        return false;
      }

      if (!this.form.description || this.form.description.trim() === '' || this.form.description.length === 0) {
        this.$message.warning('Descipción esta vacio!');
        return false;
      }
      return true;
    },

    async submit() {
      if (this.validateFields()) {
        this.isSubmitting = true;
        const formdata = new FormData();
        formdata.append('id', this.form.id);
        formdata.append('name', this.form.name);
        formdata.append('email', this.form.email);
        formdata.append('phone', this.form.phone);
        formdata.append('doc_type_id', this.form.doc_type_id);
        formdata.append('number_doc', this.form.number_doc);
        formdata.append('birthday', this.form.birthday);
        formdata.append('prefix', this.form.prefix);
        formdata.append('description', this.form.description);

        if (this.fileList.length > 0) {
          formdata.append('file', this.fileList[0].raw);
        }

        try {
          this.loading = true;
          const request = await axios({
            url: `actualizar`,
            method: 'post',
            data: formdata,
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          const response =
            request.status == 200
              ? this.$message.success('El curso ha sido actualizado correctamente')
              : await this.$message.warning('Error al validar datos');
          this.isSubmitting = false;
          this.loading = false;
          this.fileList = [];
          $('#edit-course-modal').modal('hide');
          location.reload();
        } catch (error) {
          this.isSubmitting = false;
          this.loading = false;
          $('#edit-course-modal').modal('hide');
          console.log(error);
        }
      }
    },
  },
};
</script>
